module.exports = __webpack_public_path__ + "index/img/jiang.ba3a5b6c.png";